module.exports = __webpack_public_path__ + "static/media/view-more-dark.4405afa7.svg";